module.exports = __webpack_public_path__ + "assets/7096f628a31b9d3b572d9777f5525393.png";